export default __webpack_public_path__ + "static/media/sorting_1.7aa5461d.png";